module.exports = __webpack_public_path__ + "static/media/tank_page_cover.524a8e81.JPG";